
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"individual 44x44"}},[_c('path',{attrs:{"d":"M44 44H0V0h44zM3 41h38V3H3z","fill":"#e813a6"}}),_c('path',{attrs:{"d":"M28 15.1a.94.94 0 01.94.94V28a.94.94 0 01-.94.94H16a.94.94 0 01-.9-.94V16a.94.94 0 01.9-.9zm3.45 0a2.51 2.51 0 00-2.51-2.51H15.1a2.51 2.51 0 00-2.51 2.51v13.8a2.51 2.51 0 002.51 2.51h13.8a2.51 2.51 0 002.51-2.51zM17.61 32.67v3.76h-1.26v-3.76zm5 0v3.76h-1.24v-3.76zm2.51 0v3.76h-1.24v-3.76zm-5 0v3.76h-1.26v-3.76zm7.53 0v3.76h-1.26v-3.76zm-10-25.1v3.76h-1.3V7.57zm5 0v3.76h-1.28V7.57zm2.51 0v3.76h-1.28V7.57zm-5 0v3.76h-1.3V7.57zm7.53 0v3.76h-1.3V7.57zm5 18.82h3.76v1.26h-3.78zm0-5h3.76v1.26h-3.78zm0-2.51h3.76v1.26h-3.78zm0 5h3.76v1.26h-3.78zm0-7.53h3.76v1.26h-3.78zm-25.1 10h3.76v1.26H7.57zm0-5h3.76v1.26H7.57zm0-2.51h3.76v1.26H7.57zm0 5h3.76v1.26H7.57zm0-7.53h3.76v1.26H7.57z"}})])])
          )
        }
      }
    